// AppContext.js

import React, { createContext, useContext, useReducer } from "react";

// Context oluşturulması
const AppContext = createContext();

// İlk durum (initial state)
const initialState = {
  ethToken: localStorage.getItem("initEthToken") || null,
  solToken: localStorage.getItem("initSolToken") || null,
  ethAddress: localStorage.getItem("initEthAddress") || null,
  solAddress: localStorage.getItem("initSolAddress") || null,
  // activeNetwork: localStorage.getItem("activeNetwork") || "",
  nfts: [],
  // totalShrooms: 0,
};

// Reducer fonksiyonu
const reducer = (state, action) => {
  switch (action.type) {
    case "SETETHCREDENTIALS":
      // localStorage.setItem("activeNetwork", "ETH");
      return {
        ...state,
        ethToken: action.payload.ethToken,
        ethAddress: action.payload.ethAddress,
        // activeNetwork: "ETH",
      };
    case "SETSOLCREDENTIALS":
      // localStorage.setItem("activeNetwork", "SOL");
      return {
        ...state,
        solToken: action.payload.solToken,
        solAddress: action.payload.solAddress,
        // activeNetwork: "SOL",
      };
    case "LOGOUT":
      return {
        ...state,
        nfts: [],
        ethToken: null,
        ethAddress: null,
        solToken: null,
        solAddress: null,
      };
    // case "LOGOUTETH":
    //   return { ...state, ethToken: null, ethAddress: null };
    // case "LOGOUTSOL":
    //   return { ...state, solToken: null, solAddress: null };
    // case "SETNETWORK":
    //   localStorage.setItem("activeNetwork", action.payload);
    //   return { ...state, activeNetwork: action.payload };
    // case "SETTOTALSHROOMS":
    //   return { ...state, totalShrooms: action.payload };
    case "SETNFTS":
      return { ...state, nfts: action.payload };
    // return {
    //   ...state,
    //   nfts: {
    //     staked: [
    //       {
    //         eth: {
    //           token_id: "812",
    //           name: "Mushboomers #812",
    //           owner_address: "0xc66c8d71922825d97ed19e50287952d6b2d31879",
    //           listed_status: "unlisted",
    //           image_url:
    //             "https://ipfs.io/ipfs/QmZxfsoVaZjzwYiokaD7sPHiM5cWrz1BrrrPX4NDJCy6ZX",
    //           shrooms: 0,
    //           stake: true,
    //           market: "eth",
    //           row_num: 1,
    //         },
    //         sol: {
    //           token_id: "3TEkJNSdj5vJfNWBePgu7Wr9nBPMcBCrhrdVVhzUHd73",
    //           name: "Secret Mushboomer",
    //           owner_address: "Azof59mLYPT2TaPeDcbXeYjvQukZ5XseP2uXRkzwXru4",
    //           listed_status: "unlisted",
    //           image_url:
    //             "https://bafybeih53xtdm4g4uw4ivlofogyjsof3aoyuntwot5jrf5knf2s7xo4zcm.ipfs.nftstorage.link",
    //           shrooms: 11.0,
    //           stake: true,
    //           market: "sol",
    //           row_num: 1,
    //         },
    //       },
    //       {
    //         eth: {
    //           token_id: "952",
    //           name: "Mushboomers #952",
    //           owner_address: "0xc66c8d71922825d97ed19e50287952d6b2d31879",
    //           listed_status: "unlisted",
    //           image_url:
    //             "https://ipfs.io/ipfs/QmQ29jd2wQBJEK74j7xJsqERe6hAizFbB8d49S3H1GQNyt",
    //           shrooms: 0,
    //           stake: true,
    //           market: "eth",
    //           row_num: 2,
    //         },
    //         sol: {
    //           token_id: "45eiSkCYZ2RNze416FW9KasKAwNzjVWzrUNfxVqK7qQb",
    //           name: "Secret Mushboomer",
    //           owner_address: "Azof59mLYPT2TaPeDcbXeYjvQukZ5XseP2uXRkzwXru4",
    //           listed_status: "unlisted",
    //           image_url:
    //             "https://bafybeih53xtdm4g4uw4ivlofogyjsof3aoyuntwot5jrf5knf2s7xo4zcm.ipfs.nftstorage.link",
    //           shrooms: 10.0,
    //           stake: true,
    //           market: "sol",
    //           row_num: 2,
    //         },
    //       },
    //       {
    //         eth: "",
    //         sol: {
    //           token_id: "4naZZaaR7umP8jAufzrcJkZVZ28Dg5vwRjUAZPMJcGkt",
    //           name: "Secret Mushboomer",
    //           owner_address: "Azof59mLYPT2TaPeDcbXeYjvQukZ5XseP2uXRkzwXru4",
    //           listed_status: "unlisted",
    //           image_url:
    //             "https://bafybeih53xtdm4g4uw4ivlofogyjsof3aoyuntwot5jrf5knf2s7xo4zcm.ipfs.nftstorage.link",
    //           shrooms: 10.0,
    //           stake: true,
    //           market: "sol",
    //           row_num: 3,
    //         },
    //       },
    //       {
    //         eth: "",
    //         sol: {
    //           token_id: "4qwkE9eG3MnRHcjvKtiQXgaeLTdJS8upvPGRXE3FDx3e",
    //           name: "Secret Mushboomer",
    //           owner_address: "Azof59mLYPT2TaPeDcbXeYjvQukZ5XseP2uXRkzwXru4",
    //           listed_status: "unlisted",
    //           image_url:
    //             "https://bafybeih53xtdm4g4uw4ivlofogyjsof3aoyuntwot5jrf5knf2s7xo4zcm.ipfs.nftstorage.link",
    //           shrooms: 10.0,
    //           stake: true,
    //           market: "sol",
    //           row_num: 4,
    //         },
    //       },
    //       {
    //         eth: "",
    //         sol: {
    //           token_id: "5ugAx2AnyW84tNtJ5YT16kz97nTpFTqrF9bayxNk1hgj",
    //           name: "Secret Mushboomer",
    //           owner_address: "Azof59mLYPT2TaPeDcbXeYjvQukZ5XseP2uXRkzwXru4",
    //           listed_status: "unlisted",
    //           image_url:
    //             "https://bafybeih53xtdm4g4uw4ivlofogyjsof3aoyuntwot5jrf5knf2s7xo4zcm.ipfs.nftstorage.link",
    //           shrooms: 10.0,
    //           stake: true,
    //           market: "sol",
    //           row_num: 5,
    //         },
    //       },
    //       {
    //         eth: "",
    //         sol: {
    //           token_id: "5yFwMTbycnGtWxyV4Vca2cPbJNFLWEzyASKG7ctw5fm5",
    //           name: "Secret Mushboomer",
    //           owner_address: "Azof59mLYPT2TaPeDcbXeYjvQukZ5XseP2uXRkzwXru4",
    //           listed_status: "unlisted",
    //           image_url:
    //             "https://bafybeih53xtdm4g4uw4ivlofogyjsof3aoyuntwot5jrf5knf2s7xo4zcm.ipfs.nftstorage.link",
    //           shrooms: 10.0,
    //           stake: true,
    //           market: "sol",
    //           row_num: 6,
    //         },
    //       },
    //       {
    //         eth: "",
    //         sol: {
    //           token_id: "6RmHqwCCY59dyCsd4gR29VwZthCkm4gmS3BrnxbsiLo2",
    //           name: "Secret Mushboomer",
    //           owner_address: "Azof59mLYPT2TaPeDcbXeYjvQukZ5XseP2uXRkzwXru4",
    //           listed_status: "unlisted",
    //           image_url:
    //             "https://bafybeih53xtdm4g4uw4ivlofogyjsof3aoyuntwot5jrf5knf2s7xo4zcm.ipfs.nftstorage.link",
    //           shrooms: 10.0,
    //           stake: true,
    //           market: "sol",
    //           row_num: 7,
    //         },
    //       },
    //       {
    //         eth: "",
    //         sol: {
    //           token_id: "6uka7zw1U2wp1YCq5UZiSg9RfHzPUCTkixeGPEGHfGHi",
    //           name: "Secret Mushboomer",
    //           owner_address: "Azof59mLYPT2TaPeDcbXeYjvQukZ5XseP2uXRkzwXru4",
    //           listed_status: "unlisted",
    //           image_url:
    //             "https://bafybeih53xtdm4g4uw4ivlofogyjsof3aoyuntwot5jrf5knf2s7xo4zcm.ipfs.nftstorage.link",
    //           shrooms: 10.0,
    //           stake: true,
    //           market: "sol",
    //           row_num: 8,
    //         },
    //       },
    //       {
    //         eth: "",
    //         sol: {
    //           token_id: "6wdhFXGXCw2GYKx6XqunXC4ApdNpZTdjMNqFhnJZuot5",
    //           name: "Secret Mushboomer",
    //           owner_address: "Azof59mLYPT2TaPeDcbXeYjvQukZ5XseP2uXRkzwXru4",
    //           listed_status: "unlisted",
    //           image_url:
    //             "https://bafybeih53xtdm4g4uw4ivlofogyjsof3aoyuntwot5jrf5knf2s7xo4zcm.ipfs.nftstorage.link",
    //           shrooms: 10.0,
    //           stake: true,
    //           market: "sol",
    //           row_num: 9,
    //         },
    //       },
    //       {
    //         eth: "",
    //         sol: {
    //           token_id: "76qRbWvw4vC4SbL6K3aoX6atCLKjpHpVRqBnB5gpnwmz",
    //           name: "Secret Mushboomer",
    //           owner_address: "Azof59mLYPT2TaPeDcbXeYjvQukZ5XseP2uXRkzwXru4",
    //           listed_status: "unlisted",
    //           image_url:
    //             "https://bafybeih53xtdm4g4uw4ivlofogyjsof3aoyuntwot5jrf5knf2s7xo4zcm.ipfs.nftstorage.link",
    //           shrooms: 10.0,
    //           stake: true,
    //           market: "sol",
    //           row_num: 10,
    //         },
    //       },
    //       {
    //         eth: "",
    //         sol: {
    //           token_id: "8XGLnY6jMcYzA5tvbPp4EHonE82dM5jnuH5SdsL8R5ik",
    //           name: "Secret Mushboomer",
    //           owner_address: "Azof59mLYPT2TaPeDcbXeYjvQukZ5XseP2uXRkzwXru4",
    //           listed_status: "unlisted",
    //           image_url:
    //             "https://bafybeih53xtdm4g4uw4ivlofogyjsof3aoyuntwot5jrf5knf2s7xo4zcm.ipfs.nftstorage.link",
    //           shrooms: 10.0,
    //           stake: true,
    //           market: "sol",
    //           row_num: 11,
    //         },
    //       },
    //       {
    //         eth: "",
    //         sol: {
    //           token_id: "A5S6QZiXssQ9XgKbf3hwGnswPcG6s1Le744gqHh61R5r",
    //           name: "Secret Mushboomer",
    //           owner_address: "Azof59mLYPT2TaPeDcbXeYjvQukZ5XseP2uXRkzwXru4",
    //           listed_status: "unlisted",
    //           image_url:
    //             "https://bafybeih53xtdm4g4uw4ivlofogyjsof3aoyuntwot5jrf5knf2s7xo4zcm.ipfs.nftstorage.link",
    //           shrooms: 10.0,
    //           stake: true,
    //           market: "sol",
    //           row_num: 12,
    //         },
    //       },
    //       {
    //         eth: "",
    //         sol: {
    //           token_id: "A9PTgRdKRvnWQAJPtcKC4XkSop4fW5BinuWQMifvuBb6",
    //           name: "Secret Mushboomer",
    //           owner_address: "Azof59mLYPT2TaPeDcbXeYjvQukZ5XseP2uXRkzwXru4",
    //           listed_status: "unlisted",
    //           image_url:
    //             "https://bafybeih53xtdm4g4uw4ivlofogyjsof3aoyuntwot5jrf5knf2s7xo4zcm.ipfs.nftstorage.link",
    //           shrooms: 10.0,
    //           stake: true,
    //           market: "sol",
    //           row_num: 13,
    //         },
    //       },
    //       {
    //         eth: "",
    //         sol: {
    //           token_id: "BujHCXVAKUQJCyBpHqw7mK3dXWUV7h5BQXMiHkyJPYQ1",
    //           name: "Secret Mushboomer",
    //           owner_address: "Azof59mLYPT2TaPeDcbXeYjvQukZ5XseP2uXRkzwXru4",
    //           listed_status: "unlisted",
    //           image_url:
    //             "https://bafybeih53xtdm4g4uw4ivlofogyjsof3aoyuntwot5jrf5knf2s7xo4zcm.ipfs.nftstorage.link",
    //           shrooms: 10.0,
    //           stake: true,
    //           market: "sol",
    //           row_num: 14,
    //         },
    //       },
    //       {
    //         eth: "",
    //         sol: {
    //           token_id: "CA6hpFzbJNnedxJCcLQZL3T4nL5KcHM51tLGyCnTEKXs",
    //           name: "Secret Mushboomer",
    //           owner_address: "Azof59mLYPT2TaPeDcbXeYjvQukZ5XseP2uXRkzwXru4",
    //           listed_status: "unlisted",
    //           image_url:
    //             "https://bafybeih53xtdm4g4uw4ivlofogyjsof3aoyuntwot5jrf5knf2s7xo4zcm.ipfs.nftstorage.link",
    //           shrooms: 10.0,
    //           stake: true,
    //           market: "sol",
    //           row_num: 15,
    //         },
    //       },
    //       {
    //         eth: "",
    //         sol: {
    //           token_id: "CcQU9j57J6tHLVeVKZkQobs8DJYnSzxx3GX2ncLbqnmo",
    //           name: "Secret Mushboomer",
    //           owner_address: "Azof59mLYPT2TaPeDcbXeYjvQukZ5XseP2uXRkzwXru4",
    //           listed_status: "unlisted",
    //           image_url:
    //             "https://bafybeih53xtdm4g4uw4ivlofogyjsof3aoyuntwot5jrf5knf2s7xo4zcm.ipfs.nftstorage.link",
    //           shrooms: 10.0,
    //           stake: true,
    //           market: "sol",
    //           row_num: 16,
    //         },
    //       },
    //       {
    //         eth: "",
    //         sol: {
    //           token_id: "CyakyXJdBeaa8CdAA6isirqBjkVDtSDKEQXcnLeDycne",
    //           name: "Secret Mushboomer",
    //           owner_address: "Azof59mLYPT2TaPeDcbXeYjvQukZ5XseP2uXRkzwXru4",
    //           listed_status: "unlisted",
    //           image_url:
    //             "https://bafybeih53xtdm4g4uw4ivlofogyjsof3aoyuntwot5jrf5knf2s7xo4zcm.ipfs.nftstorage.link",
    //           shrooms: 10.0,
    //           stake: true,
    //           market: "sol",
    //           row_num: 17,
    //         },
    //       },
    //       {
    //         eth: "",
    //         sol: {
    //           token_id: "EpqEH5sRsNLbNxm4MMkh5hArsZJ94J7RmMhMC1G2u1mV",
    //           name: "Secret Mushboomer",
    //           owner_address: "Azof59mLYPT2TaPeDcbXeYjvQukZ5XseP2uXRkzwXru4",
    //           listed_status: "unlisted",
    //           image_url:
    //             "https://bafybeih53xtdm4g4uw4ivlofogyjsof3aoyuntwot5jrf5knf2s7xo4zcm.ipfs.nftstorage.link",
    //           shrooms: 10.0,
    //           stake: true,
    //           market: "sol",
    //           row_num: 18,
    //         },
    //       },
    //       {
    //         eth: "",
    //         sol: {
    //           token_id: "G8YCqiQGVhTcz136o1QDh1sB2ZS4ZLRDrbyKBW5prKQN",
    //           name: "Secret Mushboomer",
    //           owner_address: "Azof59mLYPT2TaPeDcbXeYjvQukZ5XseP2uXRkzwXru4",
    //           listed_status: "unlisted",
    //           image_url:
    //             "https://bafybeih53xtdm4g4uw4ivlofogyjsof3aoyuntwot5jrf5knf2s7xo4zcm.ipfs.nftstorage.link",
    //           shrooms: 10.0,
    //           stake: true,
    //           market: "sol",
    //           row_num: 19,
    //         },
    //       },
    //       {
    //         eth: "",
    //         sol: {
    //           token_id: "GvoBuB1GBNgkatYCK626AFDxdV8DBCT3S4YYan74AoZf",
    //           name: "Secret Mushboomer",
    //           owner_address: "Azof59mLYPT2TaPeDcbXeYjvQukZ5XseP2uXRkzwXru4",
    //           listed_status: "unlisted",
    //           image_url:
    //             "https://bafybeih53xtdm4g4uw4ivlofogyjsof3aoyuntwot5jrf5knf2s7xo4zcm.ipfs.nftstorage.link",
    //           shrooms: 10.0,
    //           stake: true,
    //           market: "sol",
    //           row_num: 20,
    //         },
    //       },
    //       {
    //         eth: "",
    //         sol: {
    //           token_id: "Gy75QpQ3GFCQDn435BxSmD2msotPEhCkXwbcbuBxzTXA",
    //           name: "Secret Mushboomer",
    //           owner_address: "Azof59mLYPT2TaPeDcbXeYjvQukZ5XseP2uXRkzwXru4",
    //           listed_status: "unlisted",
    //           image_url:
    //             "https://bafybeih53xtdm4g4uw4ivlofogyjsof3aoyuntwot5jrf5knf2s7xo4zcm.ipfs.nftstorage.link",
    //           shrooms: 10.0,
    //           stake: true,
    //           market: "sol",
    //           row_num: 21,
    //         },
    //       },
    //       {
    //         eth: "",
    //         sol: {
    //           token_id: "H687YU9pPHiP5R4bnR6Me2FeNyabxVgQfuZf2tyuupha",
    //           name: "Secret Mushboomer",
    //           owner_address: "Azof59mLYPT2TaPeDcbXeYjvQukZ5XseP2uXRkzwXru4",
    //           listed_status: "unlisted",
    //           image_url:
    //             "https://bafybeih53xtdm4g4uw4ivlofogyjsof3aoyuntwot5jrf5knf2s7xo4zcm.ipfs.nftstorage.link",
    //           shrooms: 10.0,
    //           stake: true,
    //           market: "sol",
    //           row_num: 22,
    //         },
    //       },
    //     ],
    //     unstaked: [
    //       {
    //         eth: "",
    //         sol: {
    //           token_id: "3FEwQydEgX26rGNwvLxouP2zeAiv3MMD2gd37fJuNWQY",
    //           name: "Secret Mushboomer",
    //           owner_address: "Azof59mLYPT2TaPeDcbXeYjvQukZ5XseP2uXRkzwXru4",
    //           listed_status: "listed",
    //           image_url:
    //             "https://bafybeih53xtdm4g4uw4ivlofogyjsof3aoyuntwot5jrf5knf2s7xo4zcm.ipfs.nftstorage.link",
    //           shrooms: 0,
    //           stake: false,
    //           market: "sol",
    //           row_num: 1,
    //         },
    //       },
    //       {
    //         eth: "",
    //         sol: {
    //           token_id: "4ZDpUgj7nmKGEZangi7s42HZZUxR1EgLTLY7BqypPJt1",
    //           name: "Secret Mushboomer",
    //           owner_address: "Azof59mLYPT2TaPeDcbXeYjvQukZ5XseP2uXRkzwXru4",
    //           listed_status: "listed",
    //           image_url:
    //             "https://bafybeih53xtdm4g4uw4ivlofogyjsof3aoyuntwot5jrf5knf2s7xo4zcm.ipfs.nftstorage.link",
    //           shrooms: 0,
    //           stake: false,
    //           market: "sol",
    //           row_num: 2,
    //         },
    //       },
    //     ],
    //     eth_shrooms: 0,
    //     sol_shrooms: 221.0,
    //     total_shrooms: 221.0,
    //   },
    // };

    default:
      return state;
  }
};

// Context Provider bileşeni
export const AppProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <AppContext.Provider value={{ state, dispatch }}>
      {children}
    </AppContext.Provider>
  );
};

// Custom hook oluşturulması
export const useAppContext = () => {
  return useContext(AppContext);
};
